<template>
    <div class="settings-wrapper">
        <!-- Close settings -->
        <a
            v-if="!initialSetting"
            class="settings-close"
            href=""
            @click.prevent="settingsClose()"
        >
            <i class="fa-solid fa-xmark fs-4 fw-bold"/>
        </a>

        <!-- Settings form -->
        <form
            action=""
            class="col-10 col-sm-8 col-md-6 col-lg-7 col-xl-6 col-xxl-5 m-auto"
            @submit.prevent="settingsSave()"
        >
            <!-- Reset settings -->
            <a
                class="settings-reset"
                :class="{ 'd-none': !paramsChanged }"
                href=""
                data-bs-toggle="tooltip"
                data-bs-trigger="hover"
                title="Сбросить настройки"
                @click.prevent="settingsReset()"
            >
                <i class="fa-solid fa-arrow-rotate-right"/>
            </a>

            <!-- Voice -->
            <div class="mb-2">
                <label for="train-settings-voice">Голос:</label>
                <select
                    id="train-settings-voice"
                    class="form-select"
                    name="voice"
                    :value="params.voice"
                    @change="updateParam('voice', $event.target.value)"
                >
                    <option value="0">
                        გიორგი (Giorgi)
                    </option>
                    <option value="1">
                        ეკა (Eka)
                    </option>
                </select>
            </div>

            <!-- Numbers range -->
            <div class="my-2">
                <label for="train-settings-range">Диапазон чисел:</label>
                <select
                    id="train-settings-range"
                    class="form-select"
                    name="range"
                    :value="params.range"
                    @change="updateParam('range', $event.target.value)"
                >
                    <option value="10">
                        От 0 до 10
                    </option>
                    <option value="20">
                        От 0 до 20
                    </option>
                    <option value="100">
                        От 0 до 100
                    </option>
                    <option value="1000">
                        От 0 до 1000
                    </option>
                </select>
            </div>

            <!-- Questions quantity -->
            <div class="my-2">
                <label for="train-settings-quantity">Количество вопросов:</label>
                <select
                    id="train-settings-quantity"
                    class="form-select"
                    name="questionsQuantity"
                    :value="params.questionsQuantity"
                    @change="updateParam('questionsQuantity', $event.target.value)"
                >
                    <option value="10">
                        10
                    </option>
                    <option value="20">
                        20
                    </option>
                    <option value="30">
                        30
                    </option>
                    <option value="40">
                        40
                    </option>
                    <option value="50">
                        50
                    </option>
                    <option value="100">
                        100
                    </option>
                </select>
            </div>

            <!-- Correct Instantly -->
            <!-- <div class="my-2 d-flex align-items-start"> -->
            <!--     <input -->
            <!--         id="train-correct-instantly" -->
            <!--         class="form-check-input flex-shrink-0 mt-1 cursor-pointer" -->
            <!--         type="checkbox" -->
            <!--         name="correctInstantly" -->
            <!--         :checked="params.correctInstantly" -->
            <!--         @change="updateParam('correctInstantly', $event.target.checked)" -->
            <!--     > -->
            <!--     <label -->
            <!--         class="form-check-label cursor-pointer" -->
            <!--         for="train-correct-instantly" -->
            <!--     > -->
            <!--         Сразу поправлять при ошибках -->
            <!--     </label> -->
            <!-- </div> -->

            <!-- Save and start (or start over) -->
            <div class="text-center mt-3">
                <input
                    class="btn btn-danger py-1 px-4"
                    type="submit"
                    :value="initialSetting ? 'Начать' : 'Начать заново'"
                >
            </div>
        </form>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
    name: 'TrainNumbersSettings',
    emits: ['settings-saved'],
    data() {
        return {
            initialSetting: true,
        }
    },
    computed: {
        ...mapState('trainNumbersModule', ['params']),
        ...mapGetters('trainNumbersModule', ['paramsChanged']),
    },
    methods: {
        ...mapActions('trainNumbersModule', ['saveParams']),
        ...mapMutations('trainNumbersModule', [
            'CANCEL_PARAMS_CHANGES',
            'RESET_PARAMS_TO_DEFAULT',
            'UPDATE_PARAM',
        ]),

        // Save settings
        settingsSave() {
            // Save params to Local Storage
            this.saveParams()
            // Fade out the settings panel
            let data = this
            $('.settings-wrapper').fadeOut(130, function() {
                $(this).addClass('closed')
                data.initialSetting = false
            })
            // Emit the 'settings-saved' event
            this.$emit('settings-saved', this.initialSetting)
        },

        // Close settings
        settingsClose() {
            this.CANCEL_PARAMS_CHANGES()
            // Swap the settings panel to the right
            $('.settings-wrapper').addClass('closed')
        },

        // Reset settings
        settingsReset() {
            this.RESET_PARAMS_TO_DEFAULT()
            // Hide the current tooltip
            bootstrap.Tooltip.getInstance($('.settings-reset')[0]).hide()
        },

        // Update the given param in the vue storage
        updateParam(key, value) {
            this.UPDATE_PARAM({key: key, value: value})
        }
    },
}
</script>

<style scoped lang="scss">
    .settings-wrapper {
        position: absolute;
        z-index: 90;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 15px;
        background: #fff;
        transition: left .3s ease;
        .settings-close {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            width: 33px;
            height: 34px;
            align-items: center;
            justify-content: center;
        }
        .settings-reset {
            position: absolute;
            top: 1px;
            right: 1px;
            padding-right: 1px;
            color: #6c757d;
            font-size: 15px;
        }
        &.closed {
            left: 150%;
        }
        form {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            input.form-check-input {
                position: relative;
                top: 1px;
                & + label {
                    padding-left: 7px;
                }
            }
        }
    }
</style>
